import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    list: {
      overflowY: 'auto',
      overflowX: 'hidden',
      marginTop: theme.spacing(-1),
    },
    expansionPanel: {
      '&, &:first-of-type, &:last-of-type': {
        borderRadius: 0,
      },
    },
    expansionPanelSummary: {
      '&.Mui-expanded': {
        margin: 0,
      },
      '& .MuiAccordionSummary-content': {
        overflow: 'hidden',
        margin: '8px',
      },
    },
    expansionPanelDetails: {
      padding: '0px 8px 8px',
    },
  };
};
